const columns = [
  {
    title: 'Industry',
    dataIndex: 'industry',
    key: 'industry',
    width: 95,
  },
  {
    title: 'Group',
    dataIndex: 'group',
    key: 'group',
    width: 95,
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    width: 95,
  },
  {
    title: 'Actual',
    dataIndex: 'actual',
    key: 'actual',
    width: 80,
  },
  {
    title: 'Expected',
    dataIndex: 'expected',
    key: 'expected',
    width: 80,
  },
  {
    title: 'Gap %',
    dataIndex: 'gap',
    key: 'gap',
    width: 80,
  },
];

export default columns;
